<template>
  <form name="scrContact">
    <div class="formStepTitle">
      Заполните контактную информацию <span>(шаг 3 из 3)</span>
    </div>
    <div class="line1">
      <div>
        <fmInput :refs="'WORK_JOB'"></fmInput>
      </div>
      <div>
        <fmSelect :refs="'EXPER_RADIO'"></fmSelect>
      </div>
    </div>
    <div class="line3">
      <div>
        <fmInput :refs="'CONST_INCOME'"></fmInput>
      </div>
      <div>
        <fmInput :refs="'AVERAGE_EXPENSES_PER_MONTH'"></fmInput>
      </div>
      <div>
        <fmInput :refs="'AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS'"></fmInput>
      </div>
<!--      <div>-->
<!--        <fmInput :refs="'OTHER_SOURCES_OF_INCOME'"></fmInput>-->
<!--      </div>-->
    </div>
    <div class="line2">

<!--      FINANCIAL_POSITION: '',-->
      <div>
        <fmSelect :refs="'SOURCE_OF_INCOME'"></fmSelect>
      </div>
      <div>
        <fmSelect :refs="'PURPOSE_OF_THE_LOAN'"></fmSelect>
      </div>
      <div>
        <fmSelect :refs="'FINANCIAL_POSITION'"></fmSelect>
      </div>
    </div>
    <div class="line3">
      <div>
        <fmSelect :refs="'EDUCATION'"></fmSelect>
      </div>
      <div>
        <fmSelect :refs="'MARITAL_STATUS'"></fmSelect>
      </div>
       <div>
      <fmCheckBoxB class="checkB" :name="'MINOR_CHILDREN'"
              :true-value="true"
              :false-value="false"
              ></fmCheckBoxB>
    </div>

      </div>

    <nxtButton v-on:submitStep="submitStep"></nxtButton>
  </form>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: "scrContact",
    data(){
      return {
        refsStepArr:[
          'WORK_JOB',
          'EXPER_RADIO',
          'CONST_INCOME',
          // 'OTHER_SOURCES_OF_INCOME',
          'CREDHISTORY_RADIO',
          // 'MEETING_DATE',
          // 'MEETING_HOUR',
          'EDUCATION',
          'MARITAL_STATUS',
          'MINOR_CHILDREN',
          'SOURCE_OF_INCOME',
          'PURPOSE_OF_THE_LOAN',
          'FINANCIAL_POSITION',
        ],
      }
    },
    components:{
      fmInput: () => import('@/components/form/fmInput'),
      fmSelect: () => import('@/components/form/fmSelect'),
      nxtButton: () => import('@/components/form/nextButton'),
      // fmCheckBox: () => import('@/components/form/fmCheckBox'),
      fmCheckBoxB: () => import('@/components/form/fmCheckBoxB'),
    },
    methods:{
      getMeetingDate: function () {
        let date = new Date(new Date().getTime() + 1000 * 60 * 60 * 24);
        let day = date.getDate();
        let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        day = day < 10 ? '0' + day : day;
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        return {
          MEETING_DATE:date.getFullYear() + '-' + month + '-' + day,
          MEETING_HOUR: h + ':' + m
        };
      },
      insertPixel(src) {
        let pixel = document.createElement("img");
        pixel.setAttribute('style','position:absolute;width:1px;height:1px;opacity:0;top:0;left:-100px;');
        pixel.src = src;
        let targetInsert = document.getElementById("app");
        document.body.insertBefore(pixel, targetInsert);
      },
      reservSave(){
        let preSendData  =Object.assign({}, this.valueVuex);
        if (preSendData.CALC_SUMM < this.minBaseProduct.Amount) {
          //magic number, не трогай блиятть
          preSendData.CALC_SUMM = 25000;
        }
        if (preSendData.CALC_SUMM > this.maxBaseProduct.Amount) {
          preSendData.CALC_SUMM = this.maxBaseProduct.Amount;
        }
        this.$myApi.singleRequest({
          action:'SendRequest',
          data:preSendData
        }).then((res) => {
          this.$palantir.trackAction(142,JSON.stringify(res));
          if (res.pixel != undefined) {
            this.insertPixel(res.pixel);
          }
          this.$store.commit('saveSystemData',{
            target:'loanid',
            value:res.loadnId
          });

          if (window.ym) {
            // eslint-disable-next-line no-undef
            ym(51632228, 'reachGoal', 'allRequest');
          }
          if (window.ga){
            // eslint-disable-next-line no-undef
            ga('send', 'event', 'admdForm', 'admdForm');
          }
          try {
            // eslint-disable-next-line no-undef
            VK.Goal('lead')
          } catch (e) {
            console.log(e);
          }

          this.$store.dispatch('hideLoading');
          this.$store.dispatch('formRouting', 'pdlThanksReserv');

        }).catch((res) => {
          this.$palantir.trackAction(143,JSON.stringify(res));
          console.log(res);
        });
      },

      submitStep() {

        // this.reservSave();
        // return  false;



        // eslint-disable-next-line no-unreachable
        // this.$palantir.trackAction(133,this.getRedirectUrl);
      if (this.checkFormFieldValue()) {
      this.$store.dispatch('formRouting', 'confirmSms');
        } else{
          window.dblClick = false;
        }
      },
      checkFormFieldValue(){
        //проверяем заполнения полей
        let isFormFieldCorrect = true;
        this.refsStepArr.forEach(item => {
          if (this.statusVuex[item].code != 0) {
            this.$palantir.trackAction(117,item);
            this.$store.dispatch('errorShow', {
              target: item,
              value: true,
            });
            isFormFieldCorrect = false;
          }
        });
        return isFormFieldCorrect;
      }
    },
    computed:{
      ...mapState({
        valueVuex: state => state.Form.sendData,
        statusVuex: state => state.Form.workData,
        minBaseProduct:state=>state.Deal.minBaseProduct,
        maxBaseProduct:state=>state.Deal.maxBaseProduct,
      }),
    },
    mounted() {
      this.$store.dispatch('hideLoading');
      window.dblClick = false;
      let MeetingDate = this.getMeetingDate();

      this.$store.dispatch('saveSendData',{
        target:'MEETING_DATE',
        value: MeetingDate.MEETING_DATE
      });

      this.$store.dispatch('saveSendData',{
        target:'MEETING_HOUR',
        value: '12:00'
      });

      window.scrollTo({
        left:0,
        top:this.$parent.$refs.formAlign.offsetTop,
        behavior: 'smooth'
      });

      if (window.ym) {
        // eslint-disable-next-line no-undef
        ym(51632228, 'reachGoal', 'admdPdlPassport');
      }

      // if (window.ym) {
      //   // eslint-disable-next-line no-undef
      //   ym(51632228, 'reachGoal', 'admdPassport');
      //   // eslint-disable-next-line no-undef
      //   ym(51632228, 'reachGoal', 'admdChainFioPassport');
      // }
      // if (window.ga){
      //   // eslint-disable-next-line no-undef
      //   ga('send', 'event', 'admdForm', 'admdPassport');
      // }
    }
  }
</script>

<style scoped>
  .line1{}
  .line1 > div{}

/deep/.visualCheckBox{border: 1px solid #0a4d3a}
/deep/.visualCheckBox svg{stroke: #0a4d3a}
  .line2{}
   /deep/.checkB label{height: 22vw;}
  .line2 div{}
  @media screen and (min-width: 760px) {
    .line1{display: flex;align-items: center;justify-content: space-between}
    .line1 > div{width: 49.5%}
    .line2{display: flex;align-items: center;justify-content: space-between}
    .line2 > div{width: 30%}
    .line2 > div:first-child{width: 39%;}
    .line3{display: flex;justify-content: space-between}
    .line3 > div:first-child{width: 39%;}
    .line3 > div{width: 30%}
    .line3 > div{width: 30%}
    /deep/.checkB label{height: 5.8vw;font-size: 1.3vw;}
  }
  @media screen and (min-width: 1140px) {
    .line1{}
    .line1 > div{}
    .line2{}
    .line2 div{}
    .line2 div:first-child{}
    /deep/.checkB label{height: 64px;font-size: 14px;}
  }
</style>
